import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';
const P={NONE:0,LOW:1,REVIEW:2,MEDIUM:3,HIGH:4,CRITICAL:5};

function norm(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    scope:['OWNED','WATCHLIST','RESEARCH'].includes(x.scope)?x.scope:'RESEARCH',
    priority:Object.prototype.hasOwnProperty.call(P,x.priority)?x.priority:'NONE',
    readiness:['READY_FOR_DECISION','REVIEW','BLOCKED'].includes(x.readiness)?x.readiness:'REVIEW',
    nextTask:x.nextTask||null,
    thesisDrift:x.thesisDrift||'STABLE',
    fingerprint:x.fingerprint||null
  });
}
function delta(previous,current){
  const p=norm(previous), c=norm(current);
  const changes=[];
  if(p.priority!==c.priority) changes.push('PRIORITY');
  if(p.readiness!==c.readiness) changes.push('READINESS');
  if(p.nextTask!==c.nextTask) changes.push('NEXT_TASK');
  if(p.thesisDrift!==c.thesisDrift) changes.push('THESIS_DRIFT');
  if(p.fingerprint!==c.fingerprint) changes.push('EVIDENCE');

  let state='UNCHANGED';
  if(!previous) state='NEW';
  else if(!current) state='RESOLVED';
  else if(changes.length){
    const worsened = P[c.priority]>P[p.priority] || (p.readiness!=='BLOCKED'&&c.readiness==='BLOCKED');
    const improved = P[c.priority]<P[p.priority] || (p.readiness==='BLOCKED'&&c.readiness!=='BLOCKED');
    state=worsened?'WORSENED':improved?'IMPROVED':'CHANGED';
  }

  return Object.freeze({
    symbol:c.symbol||p.symbol,
    scope:c.scope||p.scope,
    state,
    changes:Object.freeze(changes),
    previousPriority:p.priority,
    currentPriority:c.priority,
    tradeSignal:false
  });
}
function compare(previousItems,currentItems){
  const prev=new Map((Array.isArray(previousItems)?previousItems:[]).map(x=>[norm(x).symbol,norm(x)]));
  const curr=new Map((Array.isArray(currentItems)?currentItems:[]).map(x=>[norm(x).symbol,norm(x)]));
  const symbols=new Set([...prev.keys(),...curr.keys()]);
  const rows=[];
  for(const s of symbols){
    if(!prev.has(s)) rows.push(Object.freeze({symbol:s,scope:curr.get(s).scope,state:'NEW',changes:Object.freeze(['NEW_ITEM']),previousPriority:'NONE',currentPriority:curr.get(s).priority,tradeSignal:false}));
    else if(!curr.has(s)) rows.push(Object.freeze({symbol:s,scope:prev.get(s).scope,state:'RESOLVED',changes:Object.freeze(['REMOVED_ITEM']),previousPriority:prev.get(s).priority,currentPriority:'NONE',tradeSignal:false}));
    else rows.push(delta(prev.get(s),curr.get(s)));
  }
  return Object.freeze(rows);
}
function meaningful(rows){
  const list=Array.isArray(rows)?rows:[];
  return Object.freeze(list.filter(x=>['NEW','WORSENED','IMPROVED','RESOLVED','CHANGED'].includes(x.state)));
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const a={symbol:'AAA',scope:'OWNED',priority:'MEDIUM',readiness:'REVIEW',nextTask:'VERIFY',thesisDrift:'STABLE',fingerprint:'1'};
  const b={...a,priority:'HIGH'};
  ok('priority increase is worsened',delta(a,b).state==='WORSENED');
  ok('priority decrease is improved',delta(b,a).state==='IMPROVED');
  ok('same item is unchanged',delta(a,a).state==='UNCHANGED');
  ok('blocked readiness is worsened',delta(a,{...a,readiness:'BLOCKED'}).state==='WORSENED');
  ok('evidence fingerprint change is detected',delta(a,{...a,fingerprint:'2'}).changes.includes('EVIDENCE'));
  const c=compare([a],[b,{symbol:'BBB',priority:'REVIEW'}]);
  ok('new symbol is detected',c.some(x=>x.symbol==='BBB'&&x.state==='NEW'));
  const d=compare([a],[]);
  ok('removed symbol is resolved',d[0].state==='RESOLVED');
  ok('meaningful filter removes unchanged',meaningful([delta(a,a),delta(a,b)]).length===1);
  ok('delta remains non-trading',delta(a,b).tradeSignal===false);
  ok('compare remains company-specific',c.every(x=>x.symbol));
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,delta,compare,meaningful,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestAttentionDeltaEngine=Object.freeze(API);
})(engineContext);
